import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  doc,
  updateDoc,
  orderBy,
  query,
  getDoc,
  where,
  addDoc
} from "firebase/firestore";
import { db } from "../firebase";
import { Link } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import "./admin.css";
import * as bootstrap from 'bootstrap';

export default function AdminReservations() {
  const [reservations, setReservations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("tous");
  const [, setSelectedVehicleId] = useState(null);
  const [selectedVehicleImages, setSelectedVehicleImages] = useState([]);

  useEffect(() => {
    fetchReservations();
  }, []);

  const fetchReservations = async () => {
    setLoading(true);
    const q = query(collection(db, "reservations"), orderBy("createdAt", "desc"));
    const snap = await getDocs(q);
    setReservations(snap.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    setLoading(false);
  };

  const now = new Date();

  const filteredReservations = reservations.filter((r) => {
    const dateDebut = r.dateDebut?.toDate ? r.dateDebut.toDate() : new Date(r.dateDebut);
    const dateFin = r.dateFin?.toDate ? r.dateFin.toDate() : new Date(r.dateFin);
    const isInRange = now >= dateDebut && now <= dateFin;

    if (filter === "enCours") return r.statut === "validée" && isInRange;
    if (filter === "enAttente") return r.statut === "en attente";
    if (filter === "libre") return r.statut === "refusée";
    if (filter === "tous") return r.statut !== "annulée";

    return true;
  });
  const [vehicules, setVehicules] = useState([]);
  const [reservationToCancel, setReservationToCancel] = useState(null);

  const fetchVehicules = async () => {
    const snap = await getDocs(collection(db, "vehicules_auto"));
    setVehicules(snap.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
  };

  useEffect(() => {
    fetchReservations();
    fetchVehicules();
  }, []);
  const fetchVehicleImages = async (vehiculeId) => {
    const snap = await getDoc(doc(db, "vehicules_auto", vehiculeId));
    if (snap.exists()) {
      const data = snap.data();
      const images = data.imageUrls || [];
      setSelectedVehicleImages(images);
    }
  };


  const handleStatusChange = async (id, newStatus) => {
    const reservation = reservations.find((r) => r.id === id);
    if (!reservation) return;

    try {
      await updateDoc(doc(db, "reservations", id), { statut: newStatus });

      // ⏲️ Mettez à jour le véhicule associé si nécessaire
      if (reservation.vehicleId) {
        const vehiculeRef = doc(db, "vehicules_auto", reservation.vehicleId);
        const snap = await getDoc(vehiculeRef);

        if (snap.exists()) {
          const vehicule = snap.data();
          let vehiculeStatut = vehicule.statut;

          const dateDebut = reservation.dateDebut?.toDate
            ? reservation.dateDebut.toDate()
            : new Date(reservation.dateDebut);
          const dateFin = reservation.dateFin?.toDate
            ? reservation.dateFin.toDate()
            : new Date(reservation.dateFin);

          const now = new Date();
          const isInRange = now >= dateDebut && now <= dateFin;

          const currentDispos = vehicule.location?.disponibilites || [];
          const newDispos = [
            ...currentDispos,
            {
              dateDebut: reservation.dateDebut,
              dateFin: reservation.dateFin,
            },
          ];

          const updatedFields = {
            location: {
              ...(vehicule.location || {}),
              disponibilites: newDispos,
            },
          };

          if (newStatus === "validée" && isInRange) {
            updatedFields.statut = "occupé";
          } else if (newStatus === "refusée") {
            const resSnap = await getDocs(
              query(collection(db, "reservations"), where("vehicleId", "==", reservation.vehicleId))
            );
            const autres = resSnap.docs.map((d) => d.data()).filter((r) => r.statut !== "refusée");
            vehiculeStatut = autres.length === 0 ? "refusé" : vehicule.statut;
            updatedFields.statut = vehiculeStatut;
          } else if (newStatus === "en attente") {
            updatedFields.statut = "en attente de validation";
          }

          await updateDoc(vehiculeRef, updatedFields);
        }
      }

      // ✅ Envoi d'email si validée
      // 📦 Validation et gestion des conflits de réservation
      
      fetchReservations(); // Mise à jour de la liste
    } catch (error) {
      console.error("❌ Erreur lors du changement de statut :", error);
    }
  };

  const updateVehiculesEnCours = async () => {
    const now = new Date();
    console.log("⏳ Vérification des véhicules avec réservation en cours :", now.toISOString());

    try {
      const snap = await getDocs(
        query(collection(db, "reservations"), where("statut", "==", "validée"))
      );

      
      const vehiculesEnCours = [];

      for (const docSnap of snap.docs) {
        const data = docSnap.data();

        console.log(`📋 Réservation ${docSnap.id}`);
        console.log("Statut :", data.statut);
        console.log("Vehicule ID :", data.vehiculeId);
        console.log("dateDebut brut :", data.dateDebut);
        console.log("dateFin brut :", data.dateFin);

        const vehiculeId = data.vehicleId; // au lieu de data.vehiculeId

        if (!vehiculeId || !data.dateDebut || !data.dateFin) {
          console.log("⛔️ Réservation ignorée (incomplète)");
          continue;
        }

        const dateDebut = data.dateDebut?.toDate ? data.dateDebut.toDate() : new Date(data.dateDebut);
        const dateFin = data.dateFin?.toDate ? data.dateFin.toDate() : new Date(data.dateFin);

        const isInRange = now >= dateDebut && now <= dateFin;

        if (isInRange) {
          // ➕ Ajouter à la liste d'affichage
          vehiculesEnCours.push({
            vehiculeId,
            dateDebut: dateDebut.toLocaleDateString(),
            dateFin: dateFin.toLocaleDateString(),
          });

          // ✅ Mettre à jour le statut du véhicule
          const vehiculeRef = doc(db, "vehicules_auto", vehiculeId);
          await updateDoc(vehiculeRef, { statut: "occupé" });
        }
      }

      // 🖨️ Affichage dans la console
      if (vehiculesEnCours.length > 0) {
        console.log("🚗 Véhicules avec réservation en cours :");
        vehiculesEnCours.forEach((v) => {
          console.log(`- ID: ${v.vehiculeId} | 📅 Du ${v.dateDebut} au ${v.dateFin}`);
        });
      } else {
        console.log("🔍 Aucun véhicule avec une réservation en cours.");
      }
      document.getElementById("successToast").style.display = "block";

      //alert(`✅ ${updatedCount} véhicule(s) mis à jour comme "occupé"`);
    } catch (error) {
      console.error("❌ Erreur mise à jour véhicules :", error);
      document.getElementById("errorToast").style.display = "block";

      //alert("❌ Erreur lors de la mise à jour");
    }
  };
  const handleManualLouer = async (e) => {
    e.preventDefault();
    const form = e.target;

    const nom = form.nom.value;
    const telephone = form.telephone.value;
    const email = form.email.value;
    const vehiculeId = form.vehiculeId.value;
    const dateDebut = new Date(form.dateDebut.value);
    const dateFin = new Date(form.dateFin.value);

    try {
      const vehiculeSnap = await getDoc(doc(db, "vehicules_auto", vehiculeId));
      const vehicule = vehiculeSnap.data();

      const reservation = {
        nom,
        telephone,
        email,
        vehicule: `${vehicule.marque} ${vehicule.modele}`,
        vehicleId: vehiculeId,
        statut: "validée",
        dateDebut,
        dateFin,
        createdAt: new Date(),
      };

      // 1. Ajouter la réservation
      await addDoc(collection(db, "reservations"), reservation);

      // 2. Mettre à jour le véhicule
      await updateDoc(doc(db, "vehicules_auto", vehiculeId), {
        statut: "occupé",
      });

      // 3. Fermer la modale
      document.querySelector("#modalLouer .btn-close").click();

      // 4. Rafraîchir
      fetchReservations();

      // 5. Créer message WhatsApp à envoyer à l'admin
      
      // Nettoyer le numéro (optionnel)
      const numeroTel = telephone.replace(/\s+/g, "").replace(/^0/, "+228");

      // ✅ Ouvrir le composeur d’appel avec ce numéro
      window.location.href = `tel:${numeroTel}`;


      // 7. Notification de succès
      alert("✅ Réservation ajoutée et message WhatsApp généré.");
    } catch (err) {
      console.error("❌ Erreur réservation manuelle :", err);
      alert("❌ Une erreur est survenue lors de l'ajout.");
    }
  };
  const openCancelModal = (reservation) => {
    setReservationToCancel(reservation);
    const modal = new bootstrap.Modal(document.getElementById("modalConfirmCancel"));
    modal.show();
  };

  const confirmCancel = async () => {
    const id = reservationToCancel?.id;
    if (!id) return;

    try {
      const reservationRef = doc(db, "reservations", id);
      const resSnap = await getDoc(reservationRef);
      const resData = resSnap.data();
      const vehiculeId = resData.vehicleId;

      // 1. Marquer comme annulée
      await updateDoc(reservationRef, { statut: "annulée" });

      // 2. Vérifier si le véhicule peut être libéré
      if (vehiculeId) {
        const q = query(
          collection(db, "reservations"),
          where("vehicleId", "==", vehiculeId),
          where("statut", "==", "validée")
        );
        const snap = await getDocs(q);
        const now = new Date();
        const stillInUse = snap.docs.some((doc) => {
          const r = doc.data();
          const start = r.dateDebut?.toDate ? r.dateDebut.toDate() : new Date(r.dateDebut);
          const end = r.dateFin?.toDate ? r.dateFin.toDate() : new Date(r.dateFin);
          return now >= start && now <= end;
        });

        if (!stillInUse) {
          await updateDoc(doc(db, "vehicules_auto", vehiculeId), {
            statut: "disponible",
          });
        }
      }

      setReservationToCancel(null);
      fetchReservations();

      const toast = document.getElementById("successToast");
      toast.querySelector(".toast-body").textContent = "✅ Réservation annulée avec succès.";
      toast.style.display = "block";
    } catch (err) {
      console.error("❌ Erreur annulation :", err);
      const toast = document.getElementById("errorToast");
      toast.querySelector(".toast-body").textContent = "❌ Une erreur est survenue.";
      toast.style.display = "block";
    }

    // Fermer le modal manuellement
    const modal = bootstrap.Modal.getInstance(document.getElementById("modalConfirmCancel"));
    modal.hide();
  };


  return (
    <>
      <div className="d-flex flex-column flex-md-row">
        <Sidebar />
        <main className="flex-grow-1 p-3" style={{ marginLeft: "250px" }}>
          <h2 className="mb-3">📋 Réservations de véhicules</h2>
          <button
            className="btn btn-primary mb-3 me-2"
            data-bs-toggle="modal"
            data-bs-target="#modalLouer"
          >
            ➕ Louer un véhicule à un client
          </button>
          <button className="btn btn-warning mb-3" onClick={updateVehiculesEnCours}>
            🔄 Mettre à jour les véhicules occupés
          </button>
          {/* Filtres */}
          <div className="mb-3 d-flex flex-wrap gap-2" style={{ backgroundColor: "#f0f0f0", padding: "10px" }}>
            <button className={`btn ${filter === "tous" ? "btn-primary" : "btn-outline-primary"}`} onClick={() => setFilter("tous")}>🔵 Tous</button>
            <button className={`btn ${filter === "enCours" ? "btn-success" : "btn-outline-success"}`} onClick={() => setFilter("enCours")}>✅ En cours de location</button>
            <button className={`btn ${filter === "enAttente" ? "btn-warning" : "btn-outline-warning"}`} onClick={() => setFilter("enAttente")}>🕒 Demande non validée</button>
            <button className={`btn ${filter === "libre" ? "btn-secondary" : "btn-outline-secondary"}`} onClick={() => setFilter("libre")}>🟢 Libre</button>
            <button className={`btn ${filter === "annulée" ? "btn-dark" : "btn-outline-dark"}`} onClick={() => setFilter("annulée")}>❌ Annulée</button>

          </div>


          {loading ? (
            <p>Chargement...</p>
          ) : filteredReservations.length === 0 ? (
            <p>Aucune réservation trouvée pour ce filtre.</p>
          ) : (
            <div className="row">
              {filteredReservations.map((r) => (
                <div className="col-md-6 col-lg-4 mb-4" key={r.id}>
                  <div className="card h-100 shadow-sm">
                    {r.imageUrl && (
                      <img
                        src={r.imageUrl}
                        alt="Véhicule réservé"
                        className="card-img-top"
                        style={{ height: "200px", objectFit: "cover" }}
                      />
                    )}
                    <div className="card-body d-flex flex-column">
                      <h5 className="card-title">{r.nom}</h5>
                      <p className="card-text mb-1"><strong>📞</strong> {r.telephone}</p>
                      <p className="card-text mb-1"><strong>🚗 Véhicule:</strong> {r.vehicule}</p>
                      <p className="card-text mb-1">
                        <strong>📅 Période :</strong>{" "}
                        du {new Date(r.dateDebut).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })} au{" "}
                        {new Date(r.dateFin).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}
                      </p>
                      <p className="card-text text-muted mb-2">
                        <small>⏱️ Demande fait le {r.createdAt?.toDate ? r.createdAt.toDate().toLocaleString() : "Date inconnue"}</small>
                      </p>
                      <div className="mt-auto">
                        <div className="mb-2">
                          <select
                            className="form-select form-select-sm"
                            value={r.statut}
                            onChange={(e) => handleStatusChange(r.id, e.target.value)}
                          >
                            <option value="en attente">🕒 En attente</option>
                            <option value="validée">✅ Validée</option>
                            <option value="refusée">❌ Refusée</option>
                          </select>
                        </div>

                        <div className="d-flex justify-content-between">
                          <Link
                            to={`/reservation/details/${r.id}`}
                            className="btn btn-sm btn-outline-primary"
                          >
                            Détails
                          </Link>
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => openCancelModal(r)}
                          >
                            🛑 Annuler la réservation
                          </button>

                        </div>

                        {/* <div className="d-flex gap-2 mt-2">
                          <button
                            className="btn btn-sm btn-success"
                            onClick={() => handleSendManualMessage(r, "whatsapp")}
                          >
                            📲 WhatsApp
                          </button>
                          <button
                            className="btn btn-sm btn-info text-white"
                            onClick={() => handleSendManualMessage(r, "email")}
                          >
                            ✉️ Email
                          </button>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
          <div className="modal fade" id="modalLouer" tabIndex="-1" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Louer un véhicule</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div className="modal-body">
                  {selectedVehicleImages.length > 0 && (
                    <div id="carouselImagesVehicule" className="carousel slide mb-3" data-bs-ride="carousel">
                      <div className="carousel-inner">
                        {selectedVehicleImages.map((url, index) => (
                          <div className={`carousel-item ${index === 0 ? "active" : ""}`} key={index}>
                            <img src={url} className="d-block w-100" style={{ maxHeight: "250px", objectFit: "cover" }} alt={`Slide ${index}`} />
                          </div>
                        ))}
                      </div>
                      {selectedVehicleImages.length > 1 && (
                        <>
                          <button className="carousel-control-prev" type="button" data-bs-target="#carouselImagesVehicule" data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Précédent</span>
                          </button>
                          <button className="carousel-control-next" type="button" data-bs-target="#carouselImagesVehicule" data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Suivant</span>
                          </button>
                        </>
                      )}
                    </div>
                  )}

                  <form onSubmit={handleManualLouer}>
                    <div className="mb-2">
                      <label>Nom</label>
                      <input type="text" className="form-control" required name="nom" />
                    </div>
                    <div className="mb-2">
                      <label>Téléphone</label>
                      <input type="tel" className="form-control" required name="telephone" />
                    </div>
                    <div className="mb-2">
                      <label>Email</label>
                      <input type="email" className="form-control" required name="email" />
                    </div>
                    <div className="mb-2">
                      <label>Véhicule</label>
                      <select
                        className="form-select"
                        required
                        name="vehiculeId"
                        onChange={(e) => {
                          const id = e.target.value;
                          setSelectedVehicleId(id);
                          fetchVehicleImages(id);
                        }}
                      >
                        <option value="">-- Sélectionner un véhicule --</option>
                        {vehicules
                          .filter((v) => v.location?.estDisponible && v.statut !== "occupé" && v.statut !== "en maintenance")
                          .map((v) => (
                            <option key={v.id} value={v.id}>
                              {v.marque} {v.modele}
                            </option>
                          ))}
                      </select>

                    </div>
                    <div className="mb-2">
                      <label>Date début</label>
                      <input type="date" className="form-control" required name="dateDebut" />
                    </div>
                    <div className="mb-2">
                      <label>Date fin</label>
                      <input type="date" className="form-control" required name="dateFin" />
                    </div>
                    <div className="modal-footer">
                      <button type="submit" className="btn btn-success">Valider</button>
                      <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Annuler</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

        </main>
      </div>
      {/* Toast de succès ou erreur */}
      <div
        className="toast align-items-center text-white bg-success border-0 position-fixed bottom-0 end-0 m-3"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        id="successToast"
        style={{ zIndex: 9999, display: "none" }}
      >
        <div className="d-flex">
          <div className="toast-body">
            ✅ Mise à jour réussie.
          </div>
          <button
            type="button"
            className="btn-close btn-close-white me-2 m-auto"
            data-bs-dismiss="toast"
            aria-label="Close"
            onClick={() => document.getElementById("successToast").style.display = "none"}
          ></button>
        </div>
      </div>

      <div
        className="toast align-items-center text-white bg-danger border-0 position-fixed bottom-0 end-0 m-3"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        id="errorToast"
        style={{ zIndex: 9999, display: "none" }}
      >
        <div className="d-flex">
          <div className="toast-body">
            ❌ Erreur lors de la mise à jour.
          </div>
          <button
            type="button"
            className="btn-close btn-close-white me-2 m-auto"
            data-bs-dismiss="toast"
            aria-label="Close"
            onClick={() => document.getElementById("errorToast").style.display = "none"}
          ></button>
        </div>
      </div>
      <div
        className="toast align-items-center text-white bg-warning border-0 position-fixed bottom-0 end-0 m-3"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        id="cancelToast"
        style={{ zIndex: 9999, display: "none" }}
      >
        <div className="d-flex">
          <div className="toast-body">
            🚫 Réservation annulée. Veuillez contacter <span className="fw-bold"></span>.
          </div>
          <button
            type="button"
            className="btn btn-sm btn-dark ms-2 me-2 btn-contact"
          >
            📞 Appeler
          </button>
          <button
            type="button"
            className="btn-close btn-close-white m-auto"
            onClick={() => (document.getElementById("cancelToast").style.display = "none")}
          ></button>
        </div>
      </div>
      <div
        className="modal fade"
        id="modalConfirmCancel"
        tabIndex="-1"
        aria-labelledby="cancelModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-danger text-white">
              <h5 className="modal-title" id="cancelModalLabel">Confirmer l’annulation</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
            </div>
            <div className="modal-body">
              <p>
                Êtes-vous sûr de vouloir <strong>annuler</strong> cette réservation ?<br />
                <strong>Nom :</strong> {reservationToCancel?.nom} <br />
                <strong>Véhicule :</strong> {reservationToCancel?.vehicule} <br />
                <strong>Période :</strong> du {reservationToCancel?.dateDebut?.toDate?.().toLocaleDateString?.()} au {reservationToCancel?.dateFin?.toDate?.().toLocaleDateString?.()}
              </p>
              <p className="text-danger mt-2">
                ⚠️ Cette action changera le statut en "annulée" et pourra libérer le véhicule.
              </p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Non, garder</button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => confirmCancel()}
              >
                Oui, annuler
              </button>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}
